import { useContext, useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AuthContext from "../../../context/auth/AuthContext";
import LandLordContext from "../../../context/landlord/LandLordContext";
import "react-toastify/dist/ReactToastify.css";
import useTranslator from "../../../hooks/useTranslator";
import { getUserDisplayName, haveValue, toast } from "../../../helper/common";
import Cancelimg from "../../../assets/img/cancel-01.svg";
import PropertyTable from "./PropertyTable";
import AddPropertyManuallyModal from "../../../components/Property/AddPropertyManuallyModal";
import { Modal } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import SkorDefaultLoader from "../../../assets/img/skorDefaultLoader.gif";
import ShareWorkspaceModal from "../../../components/Workspace/ShareWorkspaceModal";
import { useCookies } from "react-cookie";
import WelcomeModal from "../../../components/Workspace/WelcomeModal";
import { WORKSPACE_ROLES_CAPABILITIES } from "../../../Utils/workspaceRoleCapabilities";
import DataLoadedError from "../../../components/ErrorModal/DataLoadedError";
import ProcessPassedModal from "../../onboarding/ProcessPassedModal";
import ProcessFailedModal from "../../onboarding/ProcessFailedModal";
import InsuranceActivatedPopup from "../../../components/Property/InsuranceActivatedPopup";
import socket from "../../../socket";

const NewProperty = (props) => {
  const { propId, propName, setSearchPropId } = props;

  const { _t } = useTranslator();
  const navigate = useNavigate();
  const { workspaceId } = useParams();
  const [show, setShow] = useState(false);
  const [notFoundModal, setNotFoundModal] = useState(false);
  const [isAddManuallyModal, setIsAddManuallyModal] = useState(false);
  const [properties, setProperties] = useState([]);
  const [currentWorkspace, setCurrentWorkspace] = useState("");
  const queryParameters = new URLSearchParams(window.location.search);
  const truustStatus = queryParameters.get("truust_status");
  const insurancePaymentStatus = queryParameters.get(
    "truust_payment_insurance_status"
  );
  const insPropertyId = queryParameters.get("ins_property_id");
  const [cookies, setCookie, removeCookie] = useCookies(["sharedProfileLink"]);

  const [showTruustModals, setShowTruustModals] = useState({
    state: false,
    for: null,
  });
  const [showInsuranceActivatedPopup, setShowInsuranceActivatedPopup] =
    useState({ state: false, propertyData: null, propertyId: null });
  // Tracks the property waiting for insurance webhook — persists after popup closes
  const [pendingInsurancePropertyId, setPendingInsurancePropertyId] =
    useState(null);
  const [bulkShareModal, setBulkShareModal] = useState(false);

  const handleClose = () => {
    setIsAddManuallyModal(true);
    setShow(false);
  };

  const handleShow = () => {
    if (
      haveValue(formData?.street_type) &&
      haveValue(formData?.street) &&
      haveValue(formData?.street_number) &&
      haveValue(formData?.floor) &&
      haveValue(formData?.door) &&
      haveValue(formData?.province) &&
      haveValue(formData?.postcode)
    ) {
      setIsAddManuallyModal(false);
      setShow(true);
    } else {
      setNotFoundModal(true);
    }
  };

  const authContext = useContext(AuthContext);
  const { user, setErrorDataLoading, errorDataLoading } = authContext;

  const landLordContext = useContext(LandLordContext);

  const {
    addProperty,
    propertiesAll,
    loadPropertiesNew,
    getAgencyAgents,
    getTanentData,
    loadProperties,
    getPolicyDetails,
    isCustomClientWorkspace,
    getPropertyDetails,
  } = landLordContext;

  const [step, setStep] = useState(1);

  const defaultState = {
    street_type: "",
    street: "",
    street_number: "",
    postcode: "",
    staircase: "",
    floor: "",
    door: "",
    municipality: "",
    province: "",
    code_ine: "",
    code_via: "",
    cadastral_reference: "",
    area: "",
    property_reference: "",
    washrooms: "",
    bedrooms: "",
  };
  const [formData, setFormData] = useState(defaultState);

  const [page, setPage] = useState(1);
  const [limit] = useState(15);
  const [total, setTotal] = useState(0);
  const [searchVal, setSearchVal] = useState(propName ?? "");
  const [loading, setLoading] = useState(false);
  const loadingRef = useRef(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const check = properties.filter(
      (prop) =>
        prop?.street == `${formData?.street_type}, ${formData?.street}` &&
        prop?.street_number == formData?.street_number &&
        prop?.floor_number == formData?.floor &&
        prop?.flat_number == formData?.door &&
        prop?.muncipality == formData?.municipality &&
        prop?.province == formData?.province &&
        // #NOTE: TICKET: When creating a new property in the same building is detected as already created and not allowing them to create it
        prop?.staircase == formData?.staircase
    );

    if (check.length > 0) {
      toast.error(_t("propertyAlreadyExists"));
    } else {
      setSubmitLoading(true);
      await addProperty(user?._id, formData);
      setStep(1);
      setShow(false);
      setFormData(defaultState);
      setIsAddManuallyModal(false);
      setSubmitLoading(false);
      await loadData();
    }
  };

  const [filterVal, setFilterVals] = useState({
    stairway: [],
    floorNumber: [],
    letter: [],
    agent: [],
  });
  const [filterCheck, setFilterCheck] = useState({
    stairway: "",
    floorNumber: "",
    letter: "",
    property: "available",
    agent: "",
  });
  const [tanentData, setTanentData] = useState([]);
  const [isPropertyDropdown, setIsPropertyDropdown] = useState(false);
  const [tabSelected, setTabSelected] = useState("all");

  const loadData = async (newPage = 1, append = false, extraData) => {
    if (loadingRef.current || !user?._id) return;
    loadingRef.current = true;
    setLoading(true);

    try {
      let payload = {
        paginate: true,
        page: newPage,
        limit,
        property: tabSelected,
        ...extraData,
      };
      if (searchVal) {
        payload.search = searchVal;
      }
      if (propId) {
        payload.propertyId = propId;
        setSearchPropId(propId);
      }

      const res = await loadPropertiesNew(user?._id, payload);

      if (res?.properties) {
        setProperties((prev) =>
          append ? [...prev, ...res.properties] : res.properties
        );
        setPage(res?.page);
        setTotal(res?.total);
      }
    } catch (error) {
      console.log("Failed to laod properties");
      setErrorDataLoading(true);
    } finally {
      setLoading(false);
      loadingRef.current = false;
    }
  };

  const refreshWorkspaceFunc = () => {
    loadData();
    loadProperties();
  };

  const getAgency = async () => {
    getAgencyAgents()
      .then((res) => {
        const agentList = res?.data?.data;
        if (haveValue(agentList) && Array.isArray(agentList)) {
          setFilterVals((prev) => ({
            ...prev,
            agent: agentList,
          }));
        }
      })
      .catch((err) => {
        console.log(err, "Error inside getAgencyAgents");
      });
  };

  const fetchTanentData = async () => {
    try {
      const tanentData = await getTanentData();
      const dataArray = Array.isArray(tanentData?.data) ? tanentData.data : [];

      const updatedData = dataArray.map((item) => {
        const application = item?.application_id;
        if (application.participants.length > 0) {
          const participants = application.participants || [];
          return {
            ...item,
            label: item?.application_id?.title,
            share_profile_id: item?._id,
            value: item?.tenant_id?._id,
            sub_val: `with ${participants.length - 1} other tenants`,
            applicationId: item?.application_id?._id,
            application: item?.application_id,
            isApplication: true,
          };
        }
        return {
          ...item,
          label: getUserDisplayName(item?.tenant_id),
          share_profile_id: item?._id,
          value: item?.tenant_id?._id,
          sub_val: item?.tenant_id?.email,
        };
      });

      setTanentData(updatedData);
    } catch (error) {
      console.error("Error fetching tenant data:", error);
    }
  };

  useEffect(() => {
    if (haveValue(truustStatus)) {
      setShowTruustModals({ state: true, for: truustStatus });
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.delete("truust_status");

      const newQuery = currentParams.toString();
      const baseUrl = workspaceId ? `/${workspaceId}/home` : `/home`;
      const newUrl = newQuery ? `${baseUrl}?${newQuery}` : baseUrl;
      window.history.replaceState(null, "", newUrl);
    }
  }, [truustStatus]);

  // Closes the popup UI but keeps pendingInsurancePropertyId alive so the
  // socket listener continues while the user browses the property list.
  const closeInsurancePopup = () => {
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.delete("truust_payment_insurance_status");
    currentParams.delete("ins_property_id");
    const newQuery = currentParams.toString();
    const baseUrl = workspaceId ? `/${workspaceId}/home` : `/home`;
    const newUrl = newQuery ? `${baseUrl}?${newQuery}` : baseUrl;
    window.history.replaceState(null, "", newUrl);
    setShowInsuranceActivatedPopup({
      state: false,
      propertyData: null,
      propertyId: null,
    });
  };

  useEffect(() => {
    if (insurancePaymentStatus === "success" && haveValue(insPropertyId)) {
      setPendingInsurancePropertyId(insPropertyId);
      getPropertyDetails(insPropertyId).then((data) => {
        const property = data?.properties || data;
        setShowInsuranceActivatedPopup({
          state: true,
          propertyData: property,
          propertyId: insPropertyId,
        });
      });
    }
  }, [insurancePaymentStatus]);

  // Socket listener — tied to pendingInsurancePropertyId, NOT to popup open state.
  // Stays active after popup is closed so the property list updates automatically.
  useEffect(() => {
    if (!haveValue(pendingInsurancePropertyId)) return;

    const handleInsuranceStatus = async (data) => {
      if (data?.property_id !== pendingInsurancePropertyId) return;

      if (data?.status === "success") {
        // Always reload the full list so LinkedPropertiesPopup gets fresh data
        loadData();
        // If popup is still open, re-fetch and update it
        const fresh = await getPropertyDetails(pendingInsurancePropertyId);
        const property = fresh?.properties || fresh;
        setShowInsuranceActivatedPopup((prev) =>
          prev.state ? { ...prev, propertyData: property } : prev
        );
      } else {
        toast.error(_t("insurancePolicyFailed"));
        closeInsurancePopup();
        loadData();
      }

      // Stop listening — event handled
      setPendingInsurancePropertyId(null);
    };

    socket.on("contract_insurance_status", handleInsuranceStatus);
    return () => socket.off("contract_insurance_status", handleInsuranceStatus);
  }, [pendingInsurancePropertyId]);
  console.log(showTruustModals, "ShowTruustModalsShowTruustModals");

  useEffect(() => {
    fetchTanentData();
    if (haveValue(propName)) {
      setSearchVal(propName);
    } else {
      loadData();
    }
    getAgency();

    setFilterCheck((prev) => ({
      ...prev,
      property: "available",
      // property: user?.isParentLL ? "all" : "available",
    }));
    let userid = localStorage.getItem("saveduserid");

    if (haveValue(userid)) {
      loadProperties(userid);
    }
  }, [user]);
  useEffect(() => {
    const workspaceFromUrl = user?.workspaceIds?.filter(
      (val) => val?.uuid === workspaceId
    );
    setCurrentWorkspace(workspaceFromUrl?.[0]);
  }, [user?.workspaceId]);

  useEffect(() => {
    getPolicyDetails();
    isCustomClientWorkspace(user?.email);
  }, []);

  const markPropertyAwarded = (propertyId) => {
    if (haveValue(propertyId) && haveValue(properties)) {
      loadData();
    }
  };

  const searchProperties = (e) => {
    const q = e.target.value;
    setSearchVal(q);
    setPage(1);
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setProperties([]);
      loadingRef.current = false;
      loadData(1, false);
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [searchVal, tabSelected]);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
          document.body.offsetHeight - 500 &&
        !loadingRef.current &&
        properties.length < total
      ) {
        loadData(page + 1, true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [page, total, properties]);

  return (
    <>
      <div
        className="main-page-wrapper mb-4 profileRequestWrapper"
        onClick={() => setIsPropertyDropdown(false)}
      >
        <>
          <div className="profile-page marless mobile-max-less mobile-max-lesshead">
            <div className="number-properties numberProperties">
              <h2>{_t("properties")}</h2>
              <div className="d-flex align-items-center propertySearchWrapper">
                <>
                  <div className="d-flex align-items-center justify-content-center buttonBulkWrapper">
                    {WORKSPACE_ROLES_CAPABILITIES?.properties?.add?.includes(
                      user?.current_workspace_role
                    ) && (
                      <div
                        className="position-relative"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <button
                          className="addGuarantorButton d-flex align-items-center addPropertyButton bulkShareButton addNewProperty"
                          onClick={() =>
                            setIsPropertyDropdown(!isPropertyDropdown)
                          }
                        >
                          <img src="/images/addGreen.svg" />
                          {_t("addNew")}
                        </button>
                        {isPropertyDropdown && (
                          <div className="addPropertyDropdown">
                            {user?.extra_data?.skor_usage !== "personalUse" && (
                              <h4
                                onClick={() =>
                                  navigate(`/${workspaceId}/addidealist`)
                                }
                                className="d-flex align-items-center custom-gap-2"
                              >
                                <img src="/images/idealista-icon.svg" />
                                {_t("addWithIdealista")}
                              </h4>
                            )}
                            <h4
                              className="d-flex align-items-center custom-gap-2"
                              onClick={() => {
                                setStep(1);
                                setIsPropertyDropdown(false);
                                setIsAddManuallyModal(true);
                              }}
                            >
                              <img src="/images/add-manually-icon.svg" />
                              {_t("addManually")}
                            </h4>
                          </div>
                        )}
                      </div>
                    )}
                    {WORKSPACE_ROLES_CAPABILITIES?.properties?.share?.includes(
                      user?.current_workspace_role
                    ) &&
                      user?.current_workspace?._id?.toString() ===
                        currentWorkspace?._id?.toString() && (
                        <button
                          className={`bulkShareButton manageProperties ${
                            !user?.tourCompleted
                              ? "tutorial-properties-share-button"
                              : ""
                          }`}
                          onClick={() => setBulkShareModal(true)}
                        >
                          <img src="/images/bulkShareIcon.svg" />
                          {_t("bulkShare")}
                        </button>
                      )}
                  </div>
                </>
              </div>
            </div>
          </div>
          <div className="">
            {errorDataLoading ? (
              <DataLoadedError />
            ) : (
              <div className="profile-table-card">
                <div className="profile-table-header">
                  <div className="tabButtonWrapper w-100 d-flex align-items-center justify-content-between">
                    <div className="d-flex custom-gap-2">
                      {["all", "available", "linked", "awarded"].map(
                        (btnText) => (
                          <div
                            onClick={() => setTabSelected(btnText)}
                            className={`d-flex align-items-center justify-content-center tabButton cursor-pointer ${
                              btnText === tabSelected ? "tabButtonSelected" : ""
                            }`}
                            key={btnText}
                          >
                            <p>{_t(btnText)}</p>
                          </div>
                        )
                      )}
                    </div>
                    {/* {user?.isParentLL ? (
              <>
                <div className="forminput filterSelect customInput">
                  <select
                    name="agentFilter"
                    id="agentFilter"
                    onChange={(e) => handleFilterSelected("agent", e)}
                    value={filterCheck.agent}
                  >
                    <option value="">
                      {_t(
                        "agentFilter",
                        "Used in parent landlord dashboard for filtering "
                      )}
                    </option>
                    {filterVal.agent.map((val) =>
                      haveValue(val) ? (
                        <option value={val?._id}>
                          {val?.fname_companyName} {val?.lname}
                        </option>
                      ) : (
                        <></>
                      )
                    )}
                  </select>
                  <img
                    src="/images/down-arrow-grey.svg"
                    className="downArrow"
                  />
                </div>
              </>
            ) : (
              <></>
            )} */}
                    <div className="Search-bar searchbar_cls search-bar">
                      <div className="search_bar_edit">
                        <a href="#">
                          <img
                            src="/images/search-icon-grey.svg"
                            alt=""
                            className="searchIcon"
                          />
                        </a>
                        <input
                          type="text"
                          className="custom-input mb-0 input01"
                          onChange={searchProperties}
                          value={searchVal}
                          placeholder={_t("searchProperty")}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tabs-item d-block position-relative">
                  <div className="property_margin">
                    <PropertyTable
                      property={properties}
                      onPropertyAward={markPropertyAwarded}
                      tanentData={tanentData}
                      loadData={loadData}
                      propId={propId}
                      setSearchPropId={setSearchPropId}
                      loading={loading}
                    />
                    {loading ? (
                      <div className="defaultSkorLoaderParent mt-3">
                        <img
                          src={SkorDefaultLoader}
                          className="defaultSkorLoaderSmall"
                          alt="Example"
                        />
                      </div>
                    ) : (
                      (!properties || properties.length === 0) && (
                        <div className="tabs-box-pattern big_tablebg">
                          <div className="tabs-item d-block">
                            <div className="landlord_homepage ">
                              <div className="addpropertybar">
                                <img src="/images/house.svg" alt="" />
                                <h4>{_t("noPropertiesYet")}</h4>
                                <p>{_t("pleaseAddYourProperties")}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
        {isAddManuallyModal && (
          <AddPropertyManuallyModal
            step={step}
            setStep={setStep}
            handleShow={handleShow}
            formData={formData}
            setFormData={setFormData}
            handleInputChange={handleInputChange}
            defaultState={defaultState}
            handleSubmit={handleSubmit}
            isLandlord={true}
            setIsAddManuallyModal={setIsAddManuallyModal}
            submitLoading={submitLoading}
          />
        )}
        {bulkShareModal && (
          <ShareWorkspaceModal
            isOpen={bulkShareModal}
            onClose={() => setBulkShareModal(false)}
            wholeData={propertiesAll}
            dataType={"properties"}
            refreshFunc={refreshWorkspaceFunc}
          />
        )}
        <Modal
          show={show}
          className="metermodal yourAddressModal address-popup-mobile wrapper-modal"
          centered
        >
          <div className="cursor-pointer" onClick={() => setShow(false)}>
            <img
              src={Cancelimg}
              alt="icon"
              className="canceicon topRightIcon"
            />
          </div>
          <Modal.Body className="position-relative">
            <Form className="loginform" onSubmit={handleSubmit}>
              <h4>{_t("isThisYourAddress")}</h4>
              <p className="propertyName">
                {`
                            ${formData?.street_type}, ${formData?.street} ${formData?.street_number}, ${formData?.floor} - ${formData?.door}
                            ${formData?.province}, ${formData?.postcode}
                            `}
              </p>
              <div className="custom-textarea">
                <label>{_t("propertyReferenceOptional")}</label>
                <textarea
                  name="property_reference"
                  className="w-100"
                  id="property_reference"
                  rows="2"
                  onChange={handleInputChange}
                  placeholder={_t("enterReference")}
                >
                  {formData?.property_reference}
                </textarea>
              </div>
              <div className="auth-form ">
                <div className="btngroup row100 d-flex align-items-center justify-content-center custom-gap-3">
                  <button
                    className="commonButtonPropertyDark commonButtonPropertyLight"
                    type="button"
                    onClick={(e) => {
                      setStep(3);
                      handleClose();
                    }}
                  >
                    {_t("incorrect")}
                  </button>
                  <button className="commonButtonPropertyDark" type="submit">
                    {_t("correct")}
                  </button>
                </div>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
        <Modal
          show={notFoundModal}
          className="metermodal "
          centered
          onHide={(e) => setNotFoundModal(false)}
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <Form className="loginform">
              {/* <h4>{_t("Property Not Found")}</h4> */}
              <h4>{_t("upsItSeemsWeAreMissingSomeInformation")}</h4>
              <div className="auth-form ">
                <div className="btngroup row100">
                  <button
                    className="btn btnorange"
                    type="button"
                    onClick={(e) => {
                      setStep(3);
                      setNotFoundModal(false);
                    }}
                  >
                    {_t("updateManually")}
                  </button>
                </div>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      </div>

      {/* SHOW TRUUST MODAL ON SUCCESS */}
      {showTruustModals?.state && showTruustModals?.for == "success" && (
        <ProcessPassedModal
          heading={_t("paymentSuccessfullForCredits")}
          subheading={_t("creditsWillShortlyBeAddedInYourWorkspaceAccount")}
          showPopup={showTruustModals}
          buttonText={"goBackToPropertyPage"}
          handleClick={(e) => setShowTruustModals({ state: false, for: null })}
          hideBackgroundImage={true}
        />
      )}

      {/* SHOW TRUUST MODAL ON FAILURE */}
      {showTruustModals?.state && showTruustModals?.for == "failure" && (
        <ProcessFailedModal
          heading={_t("paymentFailedForCredits")}
          subheading={_t(
            "subHeadingForModalShownWhenPaymentFailsForCreditPurchase"
          )}
          showPopup={showTruustModals}
          buttonText={"goBackToPropertyPage"}
          closeModalState={(e) => {
            setShowTruustModals({ state: false, for: null });
          }}
          hideBackgroundImage={true}
        />
      )}

      {/* SHOW INSURANCE ACTIVATED POPUP ON SUCCESSFUL INSURANCE PAYMENT */}
      {showInsuranceActivatedPopup?.state && (
        <InsuranceActivatedPopup
          show={showInsuranceActivatedPopup.state}
          propertyData={showInsuranceActivatedPopup.propertyData}
          onClose={closeInsurancePopup}
          onDone={closeInsurancePopup}
        />
      )}
    </>
  );
};

export default NewProperty;
